<form (ngSubmit)="onSubmit()" #f="ngForm" novalidate>
  <h2 mat-dialog-title>{{'dialog.extra-options.title' | translate}}</h2>
  <mat-dialog-content class="pm-extra-options-dialog-content mat-typography">
    <h3 class="ownership-title">{{'dialog.extra-options.ownership' | translate}}</h3>
    @if (contextIsProcess) {
      <mat-form-field floatLabel="always">
        <mat-label>{{'dialog.contact.owner-email' | translate}}</mat-label>
        <input matInput title='' [placeholder]="parentOwner" id="pm_owner_email" name="owner_email" type="email"
          [formControl]="ownerControl">
        @if (!hasOwnerOrParent) {
          <mat-hint>{{'dialog.extra-options.no-owner' | translate}}</mat-hint>
        }
        @if (ownerControl.hasError('email')) {
          <mat-error>{{'validation.email' | translate}}</mat-error>
        }
      </mat-form-field>
    }
    @if (!contextIsProcess) {
      <div class="no-owner-bullet">{{'dialog.extra-options.bullet.owner-not-supported' | translate}}</div>
    }
    <h3 class="permission-title">{{'dialog.extra-options.permissions' | translate}}</h3>
    <mat-checkbox [(ngModel)]="inherit" name="inheritCheckbox" (change)="onInheritChange($event)">
      {{'dialog.extra-options.inherit' | translate}}
    </mat-checkbox>
    <mat-form-field>
      <mat-label>{{'dialog.extra-options.permissions.read-access' | translate}}</mat-label>
      <mat-select placeholder="{{'dialog.extra-options.permissions.everyone' | translate}}"
        [formControl]="viewerControl" (selectionChange)="onReadersChanged()" multiple>
        <mat-select-trigger>{{viewerSelectTrigger | async}}</mat-select-trigger>
        @if (readGroups.length > 0) {
          <mat-optgroup label="{{'dialog.extra-options.permissions.groups' | translate}}">
            @for (group of readGroups; track group) {
              <mat-option [value]="group" [disabled]="inherit">{{ group.name }}
              </mat-option>
            }
          </mat-optgroup>
        }
        <mat-optgroup label="{{'dialog.extra-options.permissions.users' | translate}}">
          @for (user of readUsers; track user) {
            <mat-option [value]="user" [disabled]="inherit">{{ user.name }} <span
            class="pm-fullname">{{ user.fullName}}</span>
          </mat-option>
        }
      </mat-optgroup>
    </mat-select>
    @if (readerGroupCount == 0 && readerUserCount == 0) {
      <mat-hint>
        {{'dialog.extra-options.permissions.everyone-hint-view' | translate}}
      </mat-hint>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'dialog.extra-options.permissions.edit-access' | translate}}</mat-label>
    <mat-select [formControl]="editorControl" (selectionChange)="onWritersChanged()" multiple>
      <mat-select-trigger>{{editorSelectTrigger | async}}</mat-select-trigger>
      @if (writeGroups.length > 0) {
        <mat-optgroup label="{{'dialog.extra-options.permissions.groups' | translate}}">
          @for (group of writeGroups; track group) {
            <mat-option [value]="group" [disabled]="inherit">{{ group.name }}
            </mat-option>
          }
        </mat-optgroup>
      }
      <mat-optgroup label="{{'dialog.extra-options.permissions.users' | translate}}">
        @for (user of writeUsers; track user) {
          <mat-option [value]="user" [disabled]="inherit">{{ user.name }} <span
          class="pm-fullname">{{ getFullName(user) }}</span>
        </mat-option>
      }
    </mat-optgroup>
  </mat-select>
  @if (writerGroupCount == 0 && writerUserCount == 0) {
    <mat-hint>
      {{'dialog.extra-options.permissions.everyone-hint-edit' | translate}}
    </mat-hint>
  }
</mat-form-field>
</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button type="submit" [disabled]="ownerControl.invalid || editorControl.invalid || viewerControl.invalid">{{'button.ok' | translate}}</button>
  <button mat-button type="button" (click)="onCancelClick()">{{'button.cancel' | translate}}</button>
</div>
</form>
